import React, {useEffect, useState} from 'react';

import {formatFileSize} from 'utils/common';
import CheckIcon from 'assets/svgs/actions/check.svg';
import {uploadLogo, uploadUserLogo} from 'utils/fetch';
import {getFileIcon} from 'utils/commonReact';

const SingleFile = ({
  file,
  basicUser,
  folderId,
  pageFolderId,
  onUpload,
  selected,
}) => {
  const [status, setStatus] = useState('UPLOADING');

  const uploadFile = async () => {
    if (selected.type === 'CATEGORY') {
      const savedFile = await uploadLogo({
        file,
        authToken: basicUser.authToken,
        type: 'category',
        pageType: 'COUNTRY',
        pageFolderId,
        folderId,
      });
      const newFile = await savedFile.json();
      setStatus('UPLOADED');
      onUpload(newFile.logo);
    }
    if (selected.type === 'USER' || selected.type === 'READER') {
      const savedFile = await uploadUserLogo({
        file,
        authToken: basicUser.authToken,
        default: true,
        userId: basicUser._id,
      });
      const newFile = await savedFile.json();
      setStatus('UPLOADED');
      onUpload(newFile.logo);
    }
  };

  useEffect(() => {
    if (file) {
      uploadFile(file);
    }
  }, [file]);
  return (
    <div className="d-flex border-bottom py-3 px-4">
      {getFileIcon(file)}
      <div className="d-flex flex-column w-100 ">
        <span className="mb-2">{file.name}</span>
        <span>{formatFileSize(file.size, 2)}</span>
      </div>
      {status === 'UPLOADED' ? (
        <img alt="test" src={CheckIcon} height={20} />
      ) : (
        <div className="progress-upload mx-4 w-100">
          <div
            style={{
              width: `${status === 'UPLOADING' ? 40 : 0}%`,
            }}
            className="progress-inner"
          ></div>
        </div>
      )}
    </div>
  );
};

export default SingleFile;
